import {CxEvent} from '@spartacus/core';
import {EddlSearchClickType} from '../models/eddl-adobe-tracking-data';

export class EddlSearchResultsClickEvent extends CxEvent {

  static readonly type = 'EddlSearchResultsClickEvent';
  term?: string;
  clickRank?: number;
  clickURL?: string;
  pageNumber?: number;
  location?: 'KSD' | 'SRP';
  clickTitle?: string;
  clickCategory?: EddlSearchClickType;

}
